import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR
} from '../../../redux/actions/actionTypes'

class Input extends PureComponent {
    constructor(props) {
        super(props)

        this.inputRef = React.createRef();

        this.state ={
            docType:props.doctype,
            tagId:props.tagid,
        }

        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)
        const validate= this.validate.bind(this)

        this.initState()

        // window.emitter.addListener(START_VALIDATE_TAGS, function (message) {
        //     validate()
        // })
    }

    initState(){
        let {docType}=this.state

        this.state={
            visible: true,
            disabled: (!docType || docType=="")?this.props.disabled:false,
            required:false,
            description:null,
            error:false,
            error_message:null,
            viewMode:false,
        }
    }

  async  initControl() {
    
        let {docType,tagId}=this.state

        if (!docType || !tagId) return
        
        var tagInfo =tagsConfigHelper.findTagConfig(tagId, docType)

        // console.log("Core Input.initControl()")
        // console.log(tagInfo)

            if(tagInfo){
              await  this.setState({
                    visible:tagInfo.visibled,
                    disabled: !tagInfo.enabled,
                    required:tagInfo.required,
                    description:tagInfo.tagDescription
                })

                ControlManager.setLabel(tagInfo.tagLabel,tagInfo.visibled,tagInfo.required)
                ControlManager.setSubLabel(tagInfo.tagSubLabel,tagInfo.visibled)
            }

            if(docType==="" || docType==="*"){
                this.setState({disabled:this.props.disabled})
            }
    }

   async validate() {
        let {tagId,required,description}=this.state
        let {validate_required}=this.props
        let control=this.inputRef.current

        if(!control || !tagId || !required || validate_required===false) return

       // console.log("validate : ",tagid)    
        this.setState({
            error: false,
            error_message: null
        })
        
        if(!control.value || control.value.length===0){
            let message="กรุณาระบุ " + (description!==null ? description :tagId)

          //console.log(control)

            this.setState({
                error:true,
                error_message: message
            })

         window.emitter.emit(ADD_TAG_ERROR, {
            tagId:tagId,
            description:description,
            error_message:this.state.error_message
        })
        }  
    }

   async componentWillReceiveProps(nextProps) { 
       let isChanged = false

       if (this.state.docType !== nextProps.doctype) {
           await this.setState({ docType: nextProps.doctype })
           isChanged = true
       }

       if (this.state.tagId !== nextProps.tagid) {
           await this.setState({ tagId: nextProps.tagid })
           isChanged = true
       }
       if (isChanged === true) this.initControl()

        //กรณีไม่ได้กำหนด DocType บางค่าให้เชื่อตามที่กำหนดจากข้างนอก
        if(!nextProps.doctype || nextProps.doctype===""){
            if (this.state.disabled !== nextProps.disabled) {
                this.setState({disabled:nextProps.disabled})
            }
        }
    }

    componentDidMount() {
        this.initControl()
    }

    render() {
        let { disabled, visible ,viewMode} = this.state
        if (this.props.doctype) {
            var tagInfo = tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {

                disabled = !tagInfo.enabled
                visible = tagInfo.visibled

                ControlManager.setLabel(tagInfo.tagLabel, tagInfo.visibled, tagInfo.required)
                ControlManager.setSubLabel(tagInfo.tagSubLabel, tagInfo.visibled)
            }
        }
        
        return (
            
            <input
                ref={this.inputRef}
                {...this.props}
                autoComplete={this.props.autoComplete ? this.props.autoComplete : "off"}
                className={['form-control', this.props.className].join(' ').replace(this.props.viewMode ? "form-control-search-2" : "", "").replace( disabled ? "searchable":"","")}
                disabled={disabled || this.props.viewMode ? "disabled" : null}
                style={{ visibility: visible ? "visible" : "hidden" }}
            />
        )
    }    
}

Input.defaultProps = {
    type: "text"
}

Input.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
}

export default Input